import React from 'react';
import styled from 'styled-components';
import { colors } from '../../styles';

const SecondaryActionBarWrapper = styled.div`
  width: 20rem;
  height: 100vh;
  position: fixed;
  left: 4rem;
  background: #fff;
  border-right: 1px solid ${colors.grey100};
`;

export default class SecondaryActionBar extends React.Component<any, any> {
  render() {
    return (
      <SecondaryActionBarWrapper>
        {this.props.children}
      </SecondaryActionBarWrapper>
    );
  }
}
